import React from "react";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import DiffTableCell from "../tabel-component/DiffTableCell";
import ValueItem from "../tabel-component/ValueItem";
import { dataChangedRowColorMap } from "../../constants/colors";

export default function CompareDataTableRow({
  row,
  labelId,
  isItemSelected,
  isShowBaseElev,
  handleClick,
}) {
  return (
    <TableRow
      onClick={() => handleClick(row.id1)}
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
      sx={{ backgroundColor: dataChangedRowColorMap[row.result] ?? "#FFFFFF" }}
    >
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <DiffTableCell>{row["uid1"]}</DiffTableCell>
      <DiffTableCell>{row["point_name1"]}</DiffTableCell>
      <DiffTableCell isdiff={row["latdev"]}>
        <Stack
          direction="row"
          justifyContent="center"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={1}
        >
          <ValueItem value={row["latitude1"]} />
          <ValueItem value={row["latitude2"]} />
        </Stack>
      </DiffTableCell>
      <DiffTableCell isdiff={row["longdev"]}>
        <Stack
          direction="row"
          justifyContent="center"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={1}
        >
          <ValueItem value={row["longitude1"]} />
          <ValueItem value={row["longitude2"]} />
        </Stack>
      </DiffTableCell>
      <DiffTableCell align="center" isdiff={Boolean(row["top_elevdiff"])}>
        <Stack
          direction="row"
          justifyContent="center"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={1}
        >
          <ValueItem value={row["top_elev1"]} />
          <ValueItem value={row["top_elev2"]} />
          <ValueItem value={row["top_elevdiff"]} />
        </Stack>
      </DiffTableCell>
      {isShowBaseElev && (
        <DiffTableCell isdiff={Boolean(row["base_elevdiff"])}>
          <Stack
            direction="row"
            justifyContent="center"
            divider={<Divider orientation="vertical" flexItem />}
            spacing={1}
          >
            <ValueItem value={row["base_elev1"]} />
            <ValueItem value={row["base_elev2"]} />
            <ValueItem value={row["base_elevdiff"]} />
          </Stack>
        </DiffTableCell>
      )}
      {!isShowBaseElev && (
        <DiffTableCell isdiff={Boolean(row["ellipsoidaldiff"])}>
          <Stack
            direction="row"
            justifyContent="center"
            divider={<Divider orientation="vertical" flexItem />}
            spacing={1}
          >
            <ValueItem value={row["ellipsoidal_elev1"]} />
            <ValueItem value={row["ellipsoidal_elev2"]} />
            <ValueItem value={row["ellipsoidaldiff"]} />
          </Stack>
        </DiffTableCell>
      )}
    </TableRow>
  );
}
